import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {JtsSidebarMenuComponent} from './jts-sidebar-menu.component';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {HttpClientModule} from '@angular/common/http';
import {PopupModule} from '@progress/kendo-angular-popup';
import {DialogModule, WindowModule} from '@progress/kendo-angular-dialog';
import {FormsModule} from '@angular/forms';
import {ColorPickerModule} from 'ngx-color-picker';
import { ReportAnIssueComponent } from './report-an-issue/report-an-issue.component';
import {NgxPrintDirective} from './ngx-print.directive';


@NgModule({
  declarations: [JtsSidebarMenuComponent, ReportAnIssueComponent, NgxPrintDirective],
  exports: [
    JtsSidebarMenuComponent
  ],
  imports: [
    CommonModule,
    NgScrollbarModule,
    HttpClientModule,
    PopupModule,
    DialogModule,
    FormsModule,
    ColorPickerModule,
    WindowModule
  ]
})
export class JtsSidebarMenuModule {
}
